import React, {memo} from "react";
import {useTranslation} from "react-i18next";
import {CustomTooltip} from "components/CustomTooltip";
import {CustomCounter} from "components/CustomCounter";
import {IconDeleteClose} from "components/icons/index";
import {getInitials, getFullName, isUndefined} from "helpers/helper";
import {color} from "constants/color.consts";
import cn from "classnames";

export const InitialsBadge = memo(
  ({
    firstName,
    lastName,
    isCurrentUser,
    large,
    huge,
    needTooltip,
    needClearClick,
    customTooltip,
    counter,
    onClick,
    addClass,
  }) => {
    const {t} = useTranslation();

    const firstNameStr = firstName ? `${firstName}` : "";
    const lastNameStr = lastName ? `${lastName}` : "";
    const Initials = () => (
      <React.Fragment>
        <span
          className={cn("initials-badge", {
            [addClass]: !!addClass,
            __large: !!large,
            __huge: !!huge,
            "current-user-initials": isCurrentUser,
            cpointer: !!onClick,
            "show-custom-icon": !!needClearClick,
          })}
          onClick={onClick}
        >
          {needClearClick && <IconDeleteClose color={color.red} addClass="icon-clear" />}
          {isUndefined(lastName)
            ? getInitials(firstNameStr, firstNameStr?.split(" ").at(1))
            : getInitials(firstNameStr, lastNameStr)}
        </span>
        {!!counter && counter > 0 && <CustomCounter count={counter} tiny />}
      </React.Fragment>
    );

    return needTooltip ? (
      <CustomTooltip text={`${getFullName(firstName, lastName)}\n${t(customTooltip)}`}>
        <div className="df-row-center">
          <Initials />
        </div>
      </CustomTooltip>
    ) : (
      <Initials />
    );
  }
);
